import React, { useState } from "react";
import Modal from '../Popup/Modal';
import Registration from './Registration';
import Login from "./Login/Login";

let SignInWindow = ({ fromLocationData, from, open, onClose }) => {
	const [phone, setPhone] = useState('');

	return <Modal open={open} onClose={onClose} 
	tabs={['LogIn', 'Register']}>
		<Login phone={phone} setPhone={setPhone} fromLocationData={fromLocationData} from={from} onClose={onClose} />
		<Registration initialPhone={phone} onPhoneChange={setPhone} onClose={onClose} />
	</Modal>;
};

export default SignInWindow;
